import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {lang} from "../../shared/lang/lang.nl";
import {ApiService} from "../../core/api/api.service";
import {
  RecoverPasswordRequestModel,
  RecoverPasswordResponseModel
} from "../../shared/models/forgot-password/recover-password.model";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'bergh-recover-password',
    templateUrl: './recover-password.component.html',
    styleUrls: ['./recover-password.component.scss'],
    standalone: false
})
export class RecoverPasswordComponent implements OnInit {
  public lang = lang;
  public recoverPasswordForm: UntypedFormGroup;

  constructor( private _formBuilder: UntypedFormBuilder,
               private _route: ActivatedRoute,
               private _toastr: ToastrService,
               private _api: ApiService,
               private _router: Router ) { }

  ngOnInit(): void {
    this.recoverPasswordForm = this._formBuilder.group({
      'password':['',[Validators.required, Validators.minLength(3)]],
      'repeatPassword':['',[Validators.required]]
    })
  }

  /**
   * @description methord is called on forgot password form submission.
   * @returns void
   */
  public recoverPasswordFormSubmit(): void {
    let recoverPasswordPayload: RecoverPasswordRequestModel = {
      token: this._route.snapshot.paramMap.get('token'),
      password: this.recoverPasswordForm.controls['password'].value
    }
    this._api.request('recoverPassword',recoverPasswordPayload).subscribe((result: RecoverPasswordResponseModel) => {
      this._toastr.success(result.message,'Success', {
        timeOut: environment.TOASTER_TIMEOUT,
        positionClass: environment.TOASTER_POSITION
      })
      this._router.navigate(['login']);
    })
  }

  /**
   * @description methord checks if the password and the retype password are the same
   * @returns void
   */
  public passwordCheck(): void {
    if (this.recoverPasswordForm.controls['repeatPassword'].value != this.recoverPasswordForm.controls['password'].value) {
      this.recoverPasswordForm.controls['repeatPassword'].setErrors({
        isValid: false
      });
    }
  }
}
